/*
 * Get-confirmation.ts
 * Description: Includes the declaration of a function
 * to check whether the user has email
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';

/**
 * Creating function for getting user data
 *
 * @return {Object} Promise - whether the user has confirmed their email
 */
export function getConfirmation() {
    const jwt = localStorage.getItem('jwt');
    // Creating a new instance of Promise to make JavaScript work synchronous
    return new Promise ((resolve, reject) => {
        Axios({
            url:  APIURL + 'auth/email/resend',
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {},
        }).then(() => {
            resolve();
        }).catch(() => {
            reject();
        });
    });
}
